import { NgModule } from '@angular/core';

import { CommonTextfieldModule } from '../../../Common/controls/textfield/textfield.module';
import { CommonCheckboxModule } from '../../../Common/controls/checkbox/checkbox.module';
import { CommonHiddenAutofillComponent } from '../../../Common/components/hidden_autofill/hidden_autofill.component';
import { CommonSubmitButtonModule } from '../../../Common/controls/submit_button/submit_button.module';

@NgModule({
	declarations: [
		CommonHiddenAutofillComponent,
	],
	exports: [
		CommonTextfieldModule,
		CommonCheckboxModule,
		CommonHiddenAutofillComponent,
		CommonSubmitButtonModule,
	],
})
export class AuthenticationMeetingsCommonModule {}
